export default __webpack_public_path__ + "static/media/Code_of_Ethics_2023.d9d3724b.pdf";